<template>

  <!-- TODO: It's a bit messy to have these inline styles. Move them to the stylesheet. -->
  <v-app-bar style="position: static; padding-right: 15px;"> <!-- TODO: allow to float on mobile -->

    <v-app-bar-title>
      <img
        v-if="$vuetify.theme.current.dark"
        src="/src/assets/images/logo-rectangular-white.png"
        alt="Ocra logo"
        class="app-logo"
      >
      <img
        v-if="!$vuetify.theme.current.dark"
        src="/src/assets/images/logo-rectangular-purple.png"
        alt="Ocra logo"
        class="app-logo"
      >
    </v-app-bar-title>

    <preferences-menu />

    <v-menu
      min-width="200px"
      rounded
      location="bottom"
    >

      <template v-slot:activator="{ props }">
        <v-btn
          icon
          v-bind="props"
        >
          <v-avatar
            color="app-bar-item-foreground"
            size="large"
          >
            <span class="text-h5 text-uppercase">{{ userInitials }}</span>
          </v-avatar>
        </v-btn>
      </template>

      <v-card>
        <v-card-text>
          <div class="mx-auto text-center">
            <h3>{{ user.firstName }} {{ user.lastName }}</h3>
            <p class="text-caption mt-1">
              {{ user.email }}
            </p>
            <v-divider class="my-3"></v-divider>
            <v-btn
              rounded
              variant="text"
              :to="{ name: 'profile' }"
            >
              {{ $t('titles.your_profile') }}
            </v-btn>
            <v-divider class="my-3"></v-divider>
            <v-btn
              rounded
              variant="text"
              @click="logOut()"
            >
              {{ $t('actions.log_out') }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>

    </v-menu>

    <v-app-bar-nav-icon id="mobile-nav-activator" color="app-bar-item-foreground" class="ml-4" style="margin-inline-end: 0" /> <!-- d-xl-none -->

    <v-menu activator="#mobile-nav-activator" location="bottom">
      <v-list style="min-width: 250px;">
        <v-list-item
          v-for="item in enabledNavItems"
          :title="item.title"
          :to="item.to"
          color="nav-item-active"
        >
          <template v-slot:prepend>
            <v-icon color="nav-item-icon-foreground" :icon="item.icon" />
          </template>
        </v-list-item>
      </v-list>
    </v-menu>

  </v-app-bar>

  <v-sheet class="d-none d-lg-flex justify-center py-4 mb-4 bg-surface">
    <v-tabs stacked>
      <v-tab
        v-for="item in enabledNavItems"
        :to="item.to"
      >
        <v-icon :icon="item.icon" class="mb-2" />
        {{ item.title }}
      </v-tab>
    </v-tabs>
  </v-sheet>

  <v-container fluid class="h-100" style="max-width: 1600px">

    <router-view></router-view>

  </v-container>

</template>

<script setup lang="ts">

import { computed, inject, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import store from '../../plugins/vuex'
import PreferencesMenu from '../PreferencesMenu.vue'
import type { Can } from '../../main'

const router = useRouter()

const user = reactive(store.state.auth.user)

const userInitials = computed(() => {
  return user.firstName[0] + user.lastName[0];
})

const $can = inject('$can') as Can
const { t } = useI18n()

const navItems = [

  {
    title: t('titles.locations'),
    icon: '$location',
    to: { name: 'locationIndex' },
    permission: null,
  },

  {
    title: t('titles.universal_inventory'),
    icon: '$universalInventory',
    to: { name: 'universalInventory' },
    permission: null,
  },

  {
    title: t('titles.rate_management'),
    icon: '$rateManagement',
    to: { name: 'rateManagement' },
    permission: null,
  },

  {
    title: t('titles.blackouts'),
    icon: '$blackout',
    to: { name: 'blackoutIndex' },
    permission: null,
  },

  {
    title: t('titles.reporting'),
    icon: '$report',
    to: { name: 'overviewReport' },
    permission: null,
  },

  {
    title: t('titles.users'),
    icon: '$users',
    to: { name: 'userIndex' },
    permission: 'users.index',
  },

  {
    title: t('titles.organizations'),
    icon: '$organization',
    to: { name: 'organizationIndex' },
    permission: 'organizations.manage',
  },

  {
    title: t('titles.products'),
    icon: '$product',
    to: { name: 'productIndex' },
    permission: 'products.read',
  },

]

const enabledNavItems = computed(() => {
  return navItems.filter((navItem) => {
    return navItem.permission ? $can(navItem.permission) : true
  })
})

function logOut() {
  store.dispatch('auth/logout')
    .then(() => {
      router.push({ name: 'login' })
    })
}

</script>
